import {UI} from "../../stem-core/ui/UIBase";
import {StyleSheet, styleRule, registerStyle} from "../../stem-core/ui/Style";
import type {NodeAttributes} from "../../stem-core/ui/NodeAttributes";

export class DashboardCardStyle extends StyleSheet {
    @styleRule
    card = {
        margin: "0 auto",
    };
}

@registerStyle(DashboardCardStyle)
export class DashboardCard extends UI.Element {
    extraNodeAttributes(attr: NodeAttributes) {
        attr.addClass(this.styleSheet.card);
    }
}
